<template>
  <div :class="containerClass" class="text-xs md:text-sm lg:text-md">
    <svg class="stroke-current w-5 h-5 md:w-8 md:h-8 mr-1 md:mr-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.665 25.562"><g transform="translate(0.502 0.5)"><path d="M622.9,1003.863h1.638c.46.091.924.17,1.381.274a9.182,9.182,0,0,1,6.321,12.575,74.763,74.763,0,0,1-4.847,9.114,5.114,5.114,0,0,1-3.183,2.6h-.982a4.531,4.531,0,0,1-2.8-2,62.743,62.743,0,0,1-4.786-8.66,11.792,11.792,0,0,1-1.247-4.37,9.189,9.189,0,0,1,5.937-8.864A22.531,22.531,0,0,1,622.9,1003.863Zm.806,4.444a4.652,4.652,0,1,0,4.652,4.679A4.61,4.61,0,0,0,623.706,1008.307Z" transform="translate(-614.393 -1003.863)" fill="none" stroke-miterlimit="10" stroke-width="1"/></g></svg>
    {{content}}
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true,
    },
    containerClass: {
      type: String,
      required: false,
    },
  },
};
</script>

<style>

</style>
